import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import config from 'constants/config'

function useTravelSynonymLabels() {
  const intl = useIntl()
  const travelSynonym = config.brandConfig.travelSynonym

  return useMemo(() => {
    const travelSynonymLabel = travelSynonym === 'holiday'
      ? intl.formatMessage({
          id: 'kj7bAlqlpejLlgX9rOt-',
          defaultMessage: 'holiday',
        })
      : intl.formatMessage({
          id: '3x5_LzY0SoynVQGUzjG-',
          defaultMessage: 'package',
        })

    return { travelSynonym: travelSynonymLabel }
  }, [intl, travelSynonym])
}

export default useTravelSynonymLabels
